export default {
  setList: (state, list = []) => {
    state.list = list;
  },
  setPageInfo: (state, pageInfo = { page: 1, totalPage: 2 }) => {
    state.pageInfo = pageInfo;
  },
  setMainList: (state, list = []) => {
    state.mainList = list;
  },
  setMainPageInfo: (state, pageInfo = { page: 1, totalPage: 2 }) => {
    state.mainPageInfo = pageInfo;
  },
  setDetail: (
    state,
    detail = {
      storeNo: null,
      categoryKr: '',
      categoryVn: ''
    }
  ) => {
    state.detail = detail;
  }
};
